import classnames from 'classnames';

export interface IFormGroupProps {
    children: React.ReactNode;
    className?: string;
    hasErrors?: boolean;
    isGrouped?: boolean;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function FormGroup(props: IFormGroupProps) {
    return (
        <div
            className={classnames('form-group', props.className || '', {
                'has-danger': props.hasErrors,
                'is-grouped': props.isGrouped,
            })}
        >
            {props.children}
        </div>
    );
}
